// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3cUkq","balanceDisclaimer":"posDashboard_balanceDisclaimer__1-toD"};